import React, { useContext, useState } from "react";
import { Link as DomLink, useLocation } from "react-router-dom";
import { storage } from "../../utils";
import { DiamondSearchContext } from "../../utils/stateHandlers/contexts";
import _ from "lodash";
import ShapeFilter from "./controls/filters/ShapeFilter";
import parse from "html-react-parser";
import Modal from "./controls/Modal";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import HelpIcon from "@mui/icons-material/Help";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Checkboxes, Range, RangeNominal } from "./controls/filters";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CameraAlt from "@mui/icons-material/CameraAlt";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Default, Mobile } from "../../utils/deviceHelpers";
import LocalShippingTwoToneIcon from "@mui/icons-material/LocalShippingTwoTone";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";

const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 34,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "& + .MuiSwitch-track": {
      opacity: 1,
      backgroundColor: "#939598",
    },
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#7fa04d",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    boxSizing: "border-box",
  },
}));

export default function CertDiamondFilters(props) {
  const { diamondState, dispatch } = useContext(DiamondSearchContext);
  const {
    filters,
    advancedFilters,
    showAdvancedFilters,
    searchQuery,
    tableHeaders,
    resetFilters,
    openHelpText,
    helpTextLabel,
    helpText,
  } = diamondState;
  const [showHelp, setShowHelp] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const loggedIn = storage.getStorageItem("authToken");
  const sendTo = useLocation();

  function updateFilters(filterName, filterValues) {
    const filterToUpdate = _.find(searchQuery.fields, function (field) {
      return field.name === filterName;
    });
    const rangeOrValues =
      filterName === "HooverPrice" ||
      filterName === "Carat" ||
      filterName === "LWRatio" ||
      filterName === "Table" ||
      filterName === "Depth"
        ? "range"
        : "values";
    if (filterName === "MinedOrLab") {
      clearFilters();
    }
    if (filterToUpdate) {
      if (rangeOrValues === "range") {
        filterToUpdate.range = filterValues;
        dispatch({ type: "updateSearchQuery", payload: searchQuery.fields });
      } else {
        filterToUpdate.values = filterValues;
        dispatch({ type: "updateSearchQuery", payload: searchQuery.fields });
      }
    } else {
      if (rangeOrValues === "range") {
        const fields = _.concat(searchQuery.fields, {
          name: filterName,
          range: filterValues,
        });
        dispatch({ type: "updateSearchQuery", payload: fields });
      } else {
        const fields = _.concat(searchQuery.fields, {
          name: filterName,
          values: filterValues,
        });
        dispatch({ type: "updateSearchQuery", payload: fields });
      }
    }
  }

  function clearFilters(minedOrLab) {
    dispatch({
      type: "clearFilters",
      payload: [minedOrLab],
    });
  }

  function updateCheckedBoxes(filterName, values) {
    if (
      filterName === "AsGrown" ||
      filterName === "ScsGrower" ||
      filterName === "ShipsSameDay" ||
      filterName === "ImageVideoAvailable"
    ) {
      updateFilters(filterName, [{ name: values.checked }]);
    } else {
      const searchValues = [];
      _.map(values, function (value) {
        if (value.checked === true) {
          searchValues.push({ name: value.name });
        }
        return;
      });
      updateFilters(filterName, searchValues);
    }
  }

  function updateRange(filterName, range) {
    updateFilters(filterName, range);
  }

  function updateNominalRange(filterName, marks, sliderValue) {
    const newArray = marks
      .filter(
        (m) => m.value + 0.1 > sliderValue[0] && m.value + 0.1 < sliderValue[1]
      )
      .map((m) => {
        return { name: m.label };
      });
    updateFilters(filterName, newArray);
  }

  const MinedOrLab = () => {
    const valuesForColor = _.find(searchQuery.fields, function (field) {
      return field.name === "MinedOrLab";
    });
    const valueForColor = valuesForColor && valuesForColor.values[0].name;
    const helpText = _.find(tableHeaders, function (header) {
      return header.name === "MinedOrLab";
    });

    return (
      <Grid container>
        <Grid item className="mined-filter" sx={{ width: "100%" }}>
          <Button
            disableElevation
            variant="contained"
            color={valueForColor === "M" ? "primary" : "secondary"}
            onClick={() => {
              clearFilters({
                name: "MinedOrLab",
                values: [{ name: "M" }],
              });
            }}
          >
            Mined
          </Button>
          <Button
            disableElevation
            variant="contained"
            color={valueForColor === "L" ? "primary" : "secondary"}
            onClick={() => {
              clearFilters({
                name: "MinedOrLab",
                values: [{ name: "L" }],
              });
            }}
          >
            Lab-Grown
          </Button>
          <HelpIcon
            sx={{ marginLeft: "10px" }}
            className="help-icon question-mark"
            onClick={() => setShowHelp(true)}
          />
        </Grid>
        <Modal
          title={"Mined Or Lab-Grown"}
          onClose={() => setShowHelp(false)}
          show={showHelp}
        >
          {filters.length > 0 ? parse(helpText.help_text) : ""}
        </Modal>
      </Grid>
    );
  };

  return (
    <>
      <Mobile>
        <Stack spacing={1} alignItems="center">
          <Typography>
            Need help finding the perfect diamond? &nbsp;
            <span
              className="contact-us cursor-pointer"
              onClick={() => setShowContactModal(true)}
            >
              Contact Us
            </span>
          </Typography>
          {MinedOrLab()}
          {filters &&
            filters.map((filter) => (
              <Accordion
                key={filter.name}
                square={true}
                disableGutters={true}
                sx={{ width: "100%", minHeight: "unset", paddingRight: "1rem" }}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography
                    sx={{
                      textTransform: "uppercase",
                    }}
                  >
                    {filter.label}
                    {filter.label === "Source" ||
                    filter.label === "Features" ? (
                      <DomLink
                        to={{
                          pathname: "/sub-landing/Diamond-Sources",
                        }}
                        target="_blank"
                      >
                        <HelpIcon className="help-icon question-mark" />
                      </DomLink>
                    ) : (
                      <>
                        {filter.label !== "Price" && (
                          <HelpIcon
                            className="help-icon question-mark"
                            onClick={() =>
                              dispatch({
                                type: "setOpenHelpText",
                                payload: {
                                  open: true,
                                  label: filter.label,
                                  text: parse(filter.help_text),
                                },
                              })
                            }
                          />
                        )}
                      </>
                    )}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {filter.type === "options" && filter.label === "Shape" ? (
                    <ShapeFilter updateFilters={updateFilters} />
                  ) : filter.type === "options" && filter.label !== "Shape" ? (
                    <Checkboxes
                      search={searchQuery}
                      filter={filter}
                      resetFilters={resetFilters}
                      updateCheckedBoxes={updateCheckedBoxes}
                    />
                  ) : filter.type === "enum" ? (
                    <RangeNominal
                      filter={filter}
                      resetFilters={resetFilters}
                      updateNominalRange={updateNominalRange}
                    />
                  ) : filter.type === "numeric" &&
                    filter.name !== "HooverPrice" ? (
                    <Range
                      filter={filter}
                      resetFilters={resetFilters}
                      updateRange={updateRange}
                    />
                  ) : filter.name === "HooverPrice" && !loggedIn ? (
                    <DomLink
                      to={{
                        pathname: "/login",
                        state: { sendTo: sendTo.pathname },
                      }}
                    >
                      <Button variant="contained" color="error">
                        Login For pricing
                      </Button>
                    </DomLink>
                  ) : filter.name === "HooverPrice" && loggedIn ? (
                    <Range
                      filter={filter}
                      resetFilters={resetFilters}
                      updateRange={updateRange}
                    />
                  ) : null}
                </AccordionDetails>
              </Accordion>
            ))}
          {showAdvancedFilters && (
            <>
              {advancedFilters &&
                advancedFilters.map((filter) => (
                  <Accordion
                    square={true}
                    disableGutters={true}
                    sx={{
                      width: "100%",
                      minHeight: "unset",
                      paddingRight: "1rem",
                    }}
                  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography
                        sx={{
                          textTransform: "uppercase",
                        }}
                      >
                        {filter.label}
                        {filter.label === "Source" ||
                        filter.label === "Features" ? (
                          <DomLink
                            to={{
                              pathname: "/sub-landing/Diamond-Sources",
                            }}
                            target="_blank"
                          >
                            <HelpIcon className="help-icon question-mark" />
                          </DomLink>
                        ) : (
                          <>
                            {filter.label !== "Price" && (
                              <HelpIcon
                                className="help-icon question-mark"
                                onClick={() =>
                                  dispatch({
                                    type: "setOpenHelpText",
                                    payload: {
                                      open: true,
                                      label: filter.label,
                                      text: parse(filter.help_text),
                                    },
                                  })
                                }
                              />
                            )}
                          </>
                        )}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      {filter.type === "options" && filter.label === "Shape" ? (
                        <ShapeFilter />
                      ) : filter.type === "options" &&
                        filter.label !== "Shape" ? (
                        <Checkboxes
                          search={searchQuery}
                          filter={filter}
                          resetFilters={resetFilters}
                          updateCheckedBoxes={updateCheckedBoxes}
                        />
                      ) : filter.type === "enum" ? (
                        <RangeNominal
                          filter={filter}
                          resetFilters={resetFilters}
                          updateNominalRange={updateNominalRange}
                        />
                      ) : filter.type === "numeric" ? (
                        <Range
                          filter={filter}
                          resetFilters={resetFilters}
                          updateRange={updateRange}
                        />
                      ) : null}
                    </AccordionDetails>
                  </Accordion>
                ))}
            </>
          )}
          <Stack spacing={1} sx={{ paddingBottom: "2rem" }}>
            <FormControlLabel
              control={
                <CustomSwitch
                  id="ImageVideoAvailable"
                  type="checkbox"
                  sx={{ marginLeft: "1rem" }}
                  onChange={(e) =>
                    updateCheckedBoxes("ImageVideoAvailable", {
                      name: "ImageVideoAvailable",
                      checked: e.target.checked ? "Y" : "N",
                    })
                  }
                />
              }
              label={
                <Typography
                  variant="body3"
                  sx={{ fontWeight: "800", marginLeft: "2rem" }}
                >
                  Image/Video Available <CameraAlt color="primary" />
                </Typography>
              }
            />
            {searchQuery.fields.find((f) => f.name === "MinedOrLab").values[0]
              .name === "L" && (
              <FormControlLabel
                control={
                  <CustomSwitch
                    id="ShipsSameDay"
                    type="checkbox"
                    onClick={(e) =>
                      updateCheckedBoxes("ShipsSameDay", {
                        name: "ShipsSameDay",
                        checked: e.target.checked ? "Y" : "N",
                      })
                    }
                  />
                }
                label={
                  <Typography variant="subtitle1" sx={{ marginLeft: "2rem" }}>
                    Ships Same Day <LocalShippingTwoToneIcon color="error" />
                  </Typography>
                }
              />
            )}
          </Stack>
        </Stack>
        <Divider flexItem sx={{ marginBottom: "2rem" }}>
          {!showAdvancedFilters ? (
            <Chip
              color="primary"
              label="Show More Filters"
              icon={<ArrowDropDownIcon />}
              onClick={() =>
                dispatch({ type: "showAdvancedFilters", payload: true })
              }
            />
          ) : (
            <Chip
              color="primary"
              label="Show Less Filters"
              icon={<ArrowDropUpIcon />}
              onClick={() =>
                dispatch({ type: "showAdvancedFilters", payload: false })
              }
            />
          )}
        </Divider>
      </Mobile>
      <Default>
        <Stack spacing={1} alignItems="center" sx={{ marginBottom: "2rem" }}>
          {MinedOrLab()}
          <Typography>
            Need help finding the perfect diamond? &nbsp;
            <span
              className="contact-us cursor-pointer"
              onClick={() => setShowContactModal(true)}
            >
              Contact Us
            </span>
          </Typography>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                sm: "repeat(1, 1fr)",
                md: "repeat(2, 1fr)",
                lg: "repeat(2, 1fr)",
                xl: "repeat(2, 1fr)",
              },
              paddingTop: "2rem",
            }}
          >
            {filters &&
              filters.map((filter) => (
                <Stack
                  key={filter.name}
                  direction="row"
                  spacing={2}
                  sx={{ marginLeft: "2rem", marginBottom: "1.5rem" }}
                >
                  <Typography
                    sx={{
                      width: "12%",
                      paddingTop:
                        filter.label === "Source" ||
                        filter.label === "Features" ||
                        filter.label === "Report"
                          ? "2.8rem"
                          : ".6rem",
                      textTransform: "uppercase",
                    }}
                  >
                    {filter.name === "HooverPrice" ? "Price" : filter.label}
                    {filter.label === "Source" ||
                    filter.label === "Features" ? (
                      <DomLink
                        to={{
                          pathname: "/sub-landing/Diamond-Sources",
                        }}
                        target="_blank"
                      >
                        <HelpIcon className="help-icon question-mark" />
                      </DomLink>
                    ) : (
                      <>
                        {filter.name !== "HooverPrice" && (
                          <HelpIcon
                            className="help-icon question-mark"
                            onClick={() =>
                              dispatch({
                                type: "setOpenHelpText",
                                payload: {
                                  open: true,
                                  label: filter.label,
                                  text: parse(filter.help_text),
                                },
                              })
                            }
                          />
                        )}
                      </>
                    )}
                  </Typography>
                  <Box
                    component="span"
                    sx={{
                      paddingLeft: "3rem",
                      paddingRight: "3rem",
                      width: "93%",
                    }}
                  >
                    {filter.type === "options" && filter.label === "Shape" ? (
                      <ShapeFilter updateFilters={updateFilters} />
                    ) : filter.type === "options" &&
                      filter.label !== "Shape" ? (
                      <Checkboxes
                        search={searchQuery}
                        filter={filter}
                        resetFilters={resetFilters}
                        updateCheckedBoxes={updateCheckedBoxes}
                      />
                    ) : filter.type === "enum" ? (
                      <RangeNominal
                        filter={filter}
                        resetFilters={resetFilters}
                        updateNominalRange={updateNominalRange}
                      />
                    ) : filter.type === "numeric" &&
                      filter.name !== "HooverPrice" ? (
                      <Range
                        filter={filter}
                        resetFilters={resetFilters}
                        updateRange={updateRange}
                      />
                    ) : filter.name === "HooverPrice" && !loggedIn ? (
                      <DomLink
                        to={{
                          pathname: "/login",
                          state: { sendTo: sendTo.pathname },
                        }}
                      >
                        <Button variant="contained" color="error">
                          Login For pricing
                        </Button>
                      </DomLink>
                    ) : filter.name === "HooverPrice" && loggedIn ? (
                      <Range
                        filter={filter}
                        resetFilters={resetFilters}
                        updateRange={updateRange}
                      />
                    ) : null}
                  </Box>
                </Stack>
              ))}
            {showAdvancedFilters && (
              <>
                {advancedFilters &&
                  advancedFilters.map((filter) => (
                    <Stack
                      key={filter.name}
                      direction="row"
                      spacing={2}
                      sx={{ marginLeft: "2rem", marginBottom: "1.5rem" }}
                    >
                      <Typography
                        sx={{
                          width: "12%",
                          paddingTop: ".6rem",
                          textTransform: "uppercase",
                        }}
                      >
                        {filter.label}
                        {filter.label === "Source" ||
                        filter.label === "Features" ? (
                          <a
                            href={
                              process.env.REACT_APP_PHP_SITE_URL +
                              "diamond-sources"
                            }
                            target="_blank"
                            rel="noreferrer"
                          >
                            <HelpIcon className="help-icon question-mark" />
                          </a>
                        ) : (
                          <>
                            {filter.label !== "Price" && (
                              <HelpIcon
                                className="help-icon question-mark"
                                onClick={() =>
                                  dispatch({
                                    type: "setOpenHelpText",
                                    payload: {
                                      open: true,
                                      label: filter.label,
                                      text: parse(filter.help_text),
                                    },
                                  })
                                }
                              />
                            )}
                          </>
                        )}
                      </Typography>
                      <Box
                        component="span"
                        sx={{
                          paddingLeft: "3rem",
                          paddingRight: "3rem",
                          width: "93%",
                        }}
                      >
                        {filter.type === "options" &&
                        filter.label === "Shape" ? (
                          <ShapeFilter />
                        ) : filter.type === "options" &&
                          filter.label !== "Shape" ? (
                          <Checkboxes
                            search={searchQuery}
                            filter={filter}
                            resetFilters={resetFilters}
                            updateCheckedBoxes={updateCheckedBoxes}
                          />
                        ) : filter.type === "enum" ? (
                          <RangeNominal
                            filter={filter}
                            resetFilters={resetFilters}
                            updateNominalRange={updateNominalRange}
                          />
                        ) : filter.type === "numeric" ? (
                          <Range
                            filter={filter}
                            resetFilters={resetFilters}
                            updateRange={updateRange}
                          />
                        ) : null}
                      </Box>
                    </Stack>
                  ))}
              </>
            )}
            <Stack direction="row" spacing={1} sx={{ marginLeft: "15rem" }}>
              {searchQuery.fields.find((f) => f.name === "MinedOrLab").values[0]
                .name === "L" && (
                <FormControlLabel
                  //sx={{ border: "1px solid #954738", padding: "2rem" }}
                  control={
                    <CustomSwitch
                      id="ShipsSameDay"
                      type="checkbox"
                      onClick={(e) =>
                        updateCheckedBoxes("ShipsSameDay", {
                          name: "ShipsSameDay",
                          checked: e.target.checked ? "Y" : "N",
                        })
                      }
                    />
                  }
                  label={
                    <Typography variant="subtitle1" sx={{ marginLeft: "2rem" }}>
                      Ships Same Day <LocalShippingTwoToneIcon color="error" />{" "}
                      NEW!!!
                    </Typography>
                  }
                />
              )}
              <FormControlLabel
                control={
                  <CustomSwitch
                    id="ImageVideoAvailable"
                    type="checkbox"
                    sx={{ marginLeft: "1rem" }}
                    onClick={(e) =>
                      updateCheckedBoxes("ImageVideoAvailable", {
                        name: "ImageVideoAvailable",
                        checked: e.target.checked ? "Y" : "N",
                      })
                    }
                  />
                }
                label={
                  <Typography
                    variant="body3"
                    sx={{ fontWeight: "800", marginLeft: "2rem" }}
                  >
                    Image/Video Available <CameraAlt color="primary" />
                  </Typography>
                }
              />
            </Stack>
          </Box>
          <Divider flexItem>
            {!showAdvancedFilters ? (
              <Chip
                color="primary"
                label="Show More Filters"
                icon={<ArrowDropDownIcon />}
                onClick={() =>
                  dispatch({ type: "showAdvancedFilters", payload: true })
                }
              />
            ) : (
              <Chip
                color="primary"
                label="Show Less Filters"
                icon={<ArrowDropUpIcon />}
                onClick={() =>
                  dispatch({ type: "showAdvancedFilters", payload: false })
                }
              />
            )}
          </Divider>

          <Modal
            title={helpTextLabel}
            onClose={() =>
              dispatch({
                type: "setOpenHelpText",
                payload: {
                  open: false,
                  label: "",
                  text: "",
                },
              })
            }
            show={openHelpText}
          >
            {helpText}
          </Modal>
          <Modal
            title="Contact Us"
            onClose={() => setShowContactModal(false)}
            show={showContactModal}
          />
        </Stack>
      </Default>
    </>
  );
}
